export const GLOBAL_HEADER_TEXT = "global header"
export const MAIN_MENU = "main dropdown menu"
export const MEGA_MENU = "mega menu navigation"
export const GLOBAL_NAVIGATION = "global navigation"
